import { Box, Card, CardContent, Grid } from "@mui/material";
import { Crumbs } from "../Crumbs";
import { Typography } from "@mui/material";
import { InstagramEmbed } from "react-social-media-embed";
import { Helmet } from "react-helmet";
import { RSVPButton } from "../RSVP";
import { DanceEventProvider } from "../DanceEventProvider";

const HalloweenGuide = () => {
    return <Box>
        
        <Helmet>
            <meta charSet="utf-8"/>
            <meta property="og:description" content="Austin's Halloween 2-Steppin Guide: Discover the best venues and events to celebrate Halloween with live 2-step dancing in Austin, TX."/>
            <meta property="og:title" content="Austin Halloween 2-Steppin Guide"/>
            <meta property="twitter:title" content="Austin Halloween 2-Steppin Guide"/>
            <meta property="twitter:description" content="Austin's Halloween 2-Steppin Guide: Discover the best venues and events to celebrate Halloween with live 2-step dancing in Austin, TX."/>
        </Helmet>
        <Crumbs crumbs={[{title: "Halloween Guide"}]}/>
        <Typography variant={"h4"} gutterBottom>Halloween 2-Steppin Guide</Typography>
        <Typography variant={"overline"} gutterBottom>What's the deal?</Typography>
        <Typography variant={"body2"} gutterBottom>
            The spookiest time of year is upon us once again! If you're new to honky tonkin, it may surprise you to know the only thing better than dancing to live music, is dancing to live music in a costume! Let your inner freak flag fly with your scariest or silliest costume, and join in on the fun of being someone else for a night (or 3)!
        </Typography>
        <Typography variant={"overline"} gutterBottom>
            Halloween Events:
        </Typography>
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
                <Card>
                    <CardContent>
                        <Box style={{ float: "right" }}>
                            <RSVPButton date={"2025-10-28"} venueKey={"atx-sagebrush"} />
                        </Box>
                        <Typography variant="subtitle2">Sagebrush</Typography>
                        <Typography variant="subtitle2">Tue, Oct 28th</Typography>
                        <InstagramEmbed url="https://www.instagram.com/p/DQDUOQZgC3u/?hl=en" />
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Card>
                    <CardContent>
                        <Box style={{ float: "right" }}>
                            <RSVPButton date={"2025-10-30"} venueKey={"atx-highball"} />
                        </Box>
                        <Typography variant="subtitle2">Highball</Typography>
                        <Typography variant="subtitle2">Thu, Oct 30th</Typography>
                        <InstagramEmbed url="https://www.instagram.com/p/DP4qS5NkW1c/?hl=en" />
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Card>
                    <CardContent>
                        <Box style={{ float: "right" }}>
                            <RSVPButton date={"2025-10-31"} venueKey={"atx-sagebrush"} />
                        </Box>
                        <Typography variant="subtitle2">Sagebrush</Typography>
                        <Typography variant="subtitle2">Fri, Oct 31st</Typography>
                        <InstagramEmbed url="https://www.instagram.com/p/DP4Qb4egG0U/?hl=en" />
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Card>
                    <CardContent>
                        <Box style={{ float: "right" }}>
                            <RSVPButton date={"2025-10-31"} venueKey={"atx-whitehorse"} />
                        </Box>
                        <Typography variant="subtitle2">White Horse</Typography>
                        <Typography variant="subtitle2">Fri, Oct 31st</Typography>
                        <InstagramEmbed url="https://www.instagram.com/p/DQUimzsgKoY/?hl=en" />
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Card>
                    <CardContent>
                        <Box style={{ float: "right" }}>
                            <RSVPButton date={"2025-10-31"} venueKey={"atx-broken-spoke"} />
                        </Box>
                        <Typography variant="subtitle2">Broken Spoke</Typography>
                        <Typography variant="subtitle2">Fri, Oct 31st</Typography>
                        <Typography variant="body2">
                            HAPPY HONKY-TONK HALLOWEEN
                        </Typography>
                        <Typography variant="body2">
                            <p>THE WAGONEERS w/ MONTE WARDEN 9pm - 12:30am!!</p>
                            <p>FIRST RESPONERS GET IN FREE EVERY WAGS NIGHT!!</p>

                            <p>COSTUME PARTY!! AWARDS FOR BEST COUNTRY MUSIC COSTUMES!!</p>

                            <p>WILLIE NELSON, DOLLY PARTON, REBA, GARTH, GRANDPA JONES!</p>

                            <p>THERE WILL BE PRIZES! :)</p>
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
           
        </Grid>
    </Box>

}



export default HalloweenGuide;